var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgU(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "U",
    transform: "translate(13317 17249)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4019",
    "data-name": "Rectangle 4019",
    width: 60,
    height: 60,
    transform: "translate(-13317 -17249)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6410",
    "data-name": "Path 6410",
    d: "M26.723,4.892a21.83,21.83,0,1,0,15.436,6.394A21.769,21.769,0,0,0,26.723,4.892Zm0,24.994a14.171,14.171,0,0,0-13.428,9.6,1.549,1.549,0,1,1-2.933-.994A17.341,17.341,0,0,1,20.6,27.9a10.537,10.537,0,0,1-1.253-1.069,10.42,10.42,0,0,1,0-14.741l.006-.006a10.413,10.413,0,0,1,14.735,0l.006.006a10.42,10.42,0,0,1,0,14.741L34,26.916a10.812,10.812,0,0,1-1.164.984A17.329,17.329,0,0,1,43.084,38.5a1.549,1.549,0,1,1-2.933.994,14.171,14.171,0,0,0-13.428-9.6ZM31.9,14.276a7.324,7.324,0,1,0-.071,10.437l.069-.075a7.333,7.333,0,0,0,0-10.362ZM9.093,9.092a24.932,24.932,0,1,1-7.3,17.63,24.857,24.857,0,0,1,7.3-17.63Z",
    transform: "translate(-13312.79 -17245.789)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU);
export default __webpack_public_path__ + "static/media/U.ee83c53253c89f7aa03a79e8f987c17b.svg";
export { ForwardRef as ReactComponent };